import { sectorService } from "@features/area/AreaService";
import { AreaOutputDTO } from '@features/area/types';
import createEntitySlice from "@services/createEntitySlice";

const {
  reducer: AreaReducer,
  actions: AreaActions,
  fetchAll: fetchAreas,
  fetchById: fetchAreaById,
  createEntity: createArea,
  updateEntity: updateArea,
  deleteEntity: deleteArea,
} = createEntitySlice<AreaOutputDTO>("Area", sectorService);

export {
  AreaReducer,
  AreaActions,
  fetchAreas,
  fetchAreaById,
  createArea,
  updateArea,
  deleteArea,
}; 